import React from 'react';
import Map from './components/map/Map';
import './App.css';
import { useEffect } from 'react';
import { Backdrop, CircularProgress, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import InFormAlertModal from './components/InFormAlertModal';
import ColorConstants from './defaults/ColorConstants';
import { emitCustomEvent } from 'react-custom-events';
import Events from './defaults/Events';
import { useLocation } from 'react-router-dom';
import { isNavigationAway } from './components/esri/MapEventHelper';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { setAlertMessageObj } from './redux/slices/globalContextSlice';

function Main({
    listOpen,
    isConfigLoaded,
    userInfo,
    userRoleInfo,
    mapSnackbarMessage,
    setMapSnackbarMessage,
    mapSnackbarOpen,
    setMapSnackbarOpen,
    mapSnackbarSeverity,
    setMapSnackbarSeverity,
    headerheight,
    setIsActuals,
}) {
    const useStyles = makeStyles({
        parent: {
            position: 'relative',
            backgroundColor: 'red',
            zIndex: 0,
        },
        backdrop: {
            position: 'absolute',
        },
    });
    const classes = useStyles();

    const dispatch = useDispatch();

    const showMapLoader = useSelector((state) => state.globalContext.showMapLoader);
    const showAlertPopup = useSelector((state) => state.globalContext.showAlertPopup);
    const alertMessageObj = useSelector((state) => state.globalContext.alertMessageObj);

    const location = useLocation();
    const previousPathRef = React.useRef(location.pathname);

    useEffect(() => {
        const currentPath = location.pathname;
        const isAway = isNavigationAway(previousPathRef.current, currentPath, [
            'activities',
            'treatments',
            'projects',
        ]);
        if (isAway) {
            emitCustomEvent(Events.RemoveExistingFeatureHighlight);
        }
        previousPathRef.current = currentPath;
    }, [location]);

    return (
        <>
            <InFormAlertModal
                titleText={alertMessageObj.title ?? 'Error'}
                openFlag={showAlertPopup}
                alertSeverity={alertMessageObj.severity}
                buttonMethod={() => {
                    if (alertMessageObj.callback) {
                        alertMessageObj.callback();
                    }
                    dispatch(
                        setAlertMessageObj({
                            message: '',
                            severity: '',
                            child: null,
                            callback: null,
                        })
                    );
                }}
                closeMethod={() => {
                    if (alertMessageObj.callback) {
                        alertMessageObj.callback();
                    }
                    dispatch(
                        setAlertMessageObj({
                            message: '',
                            severity: '',
                            child: null,
                            callback: null,
                        })
                    );
                }}
                displayButton={true}
            >
                {alertMessageObj && alertMessageObj.severity && alertMessageObj.message ? (
                    <Typography sx={{ marginLeft: '5px', marginRight: '5px' }}>
                        {alertMessageObj.message}
                    </Typography>
                ) : null}
                {alertMessageObj && alertMessageObj.severity && alertMessageObj.child
                    ? alertMessageObj.child
                    : null}
            </InFormAlertModal>
            <div className='map-container' style={{ marginTop: headerheight }}>
                <Backdrop
                    className={classes.backdrop}
                    sx={{ color: ColorConstants.WhiteAlien, zIndex: 100 }}
                    open={showMapLoader}
                >
                    <CircularProgress color='inherit' />
                </Backdrop>
                <div id='editPerimeterAnchorEl'></div>
                <Map
                    listOpen={listOpen}
                    isConfigLoaded={isConfigLoaded}
                    userInfo={userInfo}
                    userRoleInfo={userRoleInfo}
                    mapSnackbarMessage={mapSnackbarMessage}
                    setMapSnackbarMessage={setMapSnackbarMessage}
                    mapSnackbarOpen={mapSnackbarOpen}
                    setMapSnackbarOpen={setMapSnackbarOpen}
                    mapSnackbarSeverity={mapSnackbarSeverity}
                    setMapSnackbarSeverity={setMapSnackbarSeverity}
                    setIsActuals={setIsActuals}
                />
            </div>
        </>
    );
}

export default Main;
